<template>
  <svg viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect
      x="1.75"
      y="2.25"
      width="20.5"
      height="20.5"
      rx="5.25"
      stroke="currentColor"
      stroke-width="1.5"
    />
    <path
      d="M11.9992 13.1108C10.0478 13.1108 8.45117 11.5141 8.45117 9.56271C8.45117 7.61128 10.0478 6.01465 11.9992 6.01465C13.9507 6.01465 15.5473 7.61128 15.5473 9.56271C15.5473 11.5141 13.9507 13.1108 11.9992 13.1108ZM11.9992 7.69998C10.9792 7.69998 10.1365 8.54264 10.1365 9.56271C10.1365 10.5828 10.9792 11.4254 11.9992 11.4254C13.0193 11.4254 13.862 10.5828 13.862 9.56271C13.862 8.54264 13.0193 7.69998 11.9992 7.69998Z"
      fill="currentColor"
    />
    <path
      d="M15.8131 13.4652C15.5026 13.066 14.9704 13.0217 14.5713 13.2878C14.5713 13.2878 13.5955 13.9974 11.9989 13.9974C10.4023 13.9974 9.42656 13.2878 9.42656 13.2878C9.0274 12.9773 8.49519 13.066 8.18473 13.4652C7.87428 13.8643 7.96298 14.3965 8.36214 14.707C8.40649 14.7513 9.33785 15.461 10.8901 15.6827L8.53954 18.0776C8.18473 18.4325 8.18473 19.009 8.53954 19.3195C8.71694 19.4969 8.9387 19.5856 9.16045 19.5856C9.38221 19.5856 9.60396 19.4969 9.78136 19.3195L11.9989 17.0576L14.2164 19.3195C14.3938 19.4969 14.6156 19.5856 14.8374 19.5856C15.0591 19.5856 15.2809 19.4969 15.4583 19.3195C15.8131 18.9647 15.8131 18.4325 15.4583 18.0776L13.1077 15.6827C14.66 15.4166 15.5913 14.707 15.6357 14.707C16.0348 14.3965 16.1235 13.82 15.8131 13.4652Z"
      fill="currentColor"
    />
  </svg>
</template>
